
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 299 299","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M298.041 214.533c0-7.815-6.345-14.16-14.16-14.16H14.753c-7.816 0-14.161 6.345-14.161 14.16v28.323c0 7.816 6.345 14.161 14.161 14.161h269.128c7.815 0 14.16-6.345 14.16-14.161v-28.323zM298.041 135.308c0-7.816-6.345-14.162-14.16-14.162H14.753c-7.816 0-14.161 6.346-14.161 14.162v28.322c0 7.816 6.345 14.162 14.161 14.162h269.128c7.815 0 14.16-6.346 14.16-14.162v-28.322zM298.041 56.081c0-7.815-6.345-14.161-14.16-14.161H14.753C6.937 41.92.592 48.266.592 56.081v28.323c0 7.816 6.345 14.161 14.161 14.161h269.128c7.815 0 14.16-6.345 14.16-14.161V56.08z"}})])
          )
        }
      }
    